import { render } from "./ThePhanQuyenMenu.vue?vue&type=template&id=1ef71936"
import script from "./ThePhanQuyenMenu.vue?vue&type=script&lang=js"
export * from "./ThePhanQuyenMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__